export default "__VITE_ASSET__c3748e93__"